import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { BootstrapVue } from "bootstrap-vue";
import VueObserveVisibility from "vue-observe-visibility";
import VueScrollTo from "vue-scrollto";
import SocialSharing from "vue-social-sharing";
import VueGtag from "vue-gtag";
import Meta from "vue-meta";
import axios from "axios";

// get analytics ID from CMS
axios
  .get("https://api.blue-temple.com/configuration")
  .then(function(res) {
    var analyticsID = res.data.data.filter(obj => {
      return obj.key === "GOOGLE_ANALYTICS";
    });

    Vue.use(VueGtag, {
      config: { id: analyticsID[0].defaultValue }
    });
  })
  .catch(function() {});

// default options
Vue.use(VueScrollTo);

// Install BootstrapVue
Vue.use(BootstrapVue);

// Viewport visibility
Vue.use(VueObserveVisibility);

// social sharing
Vue.use(SocialSharing);

// Meta
Vue.use(Meta);

export const bus = new Vue();

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
